module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('ForcastButton', {
    attrs: {
      "size": 'm',
      "disabled": _vm.forecast.status === _vm.FORECAST_STATUS.DRAFT
    },
    on: {
      "click": function($event) {
        _vm.isActive = true;
      }
    }
  }, [_vm._v("view")]), _vm._v(" "), (_vm.isActive) ? _c('ItemQuantitiesModal', {
    attrs: {
      "item": _vm.item,
      "forecast": _vm.forecast
    },
    on: {
      "closed": function($event) {
        _vm.isActive = false;
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74bf8616","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forecasts/elements/table/ItemQuantitiesButton.vue
// module id = 3271
// module chunks = 0